// extracted by mini-css-extract-plugin
export default {"wrapper":"Portfolio_wrapper__eo9CR","container":"Portfolio_container__aufL7","heading":"Portfolio_heading__I34yM","showCase":"Portfolio_showCase__fCXlY"};